import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import { PageInfo } from './base';

interface Variables {
  id?: number[];
  channel?: string;
}
export interface RedeemCode {
  id: number;
  code: string;
  invalidAt: string;
  createdAt: string;
  readonly template: RedeemCodeTemplate;
  redeemRecords: RedeemCodeRecord[];
}
interface RedeemCodeTemplateListData {
  redeemCodeTemplate: RedeemCodeTemplate[];
}

export enum RedeemCodeRecordType {
  USED,
  DESTROYED,
  ALLOCATED,
}

export interface RedeemCodesConnection {
  nodes: RedeemCode[];
  pageInfo: PageInfo;
}

export interface RedeemCodeTemplate {
  id: number;
  codes: RedeemCode[];
  codesConnection?: RedeemCodesConnection;
  desc: string;
  channel: string;
  createdAt: string;
  duration: string;
  skuGroupId: number;
  skuId?: number;
  skuGroup?: SkuGroup;
  price?: number;
  activityPrice?: number;
  cost?: number;
  marketingCost?: number;
}

export interface SkuGroup {
  id: number;
  name: string;
}

export interface RedeemCodeRecord {
  id: number;
  invoiceId: number;
  orderId: number;
  redeemCodeId: number;
  userId: number;
  createdAt: string;
  type: number;
  user: {
    id: number;
    name: string;
    mobile: string;
  };
}

export const REDEEM_CODE_QUERY = gql`
  query FindTemplates($channel: String, $id: ID, $dateRange: DateRange) {
    redeemCodeTemplates(channel: $channel, id: $id) {
      id
      channel
      skuGroupId
      skuId
      skuGroup {
        id
        name
      }
      desc
      duration
      createdAt
      codes(dateRange: $dateRange) {
        id
        code
        invalidAt
        createdAt
        redeemRecords {
          createdAt
          id
          userId
          invoiceId
          type
          user {
            name
            id
            mobile
          }
        }
      }
    }
  }
`;

export class RedeemCodeTemplates extends Query<RedeemCodeTemplateListData, Variables> {}



// WEBPACK FOOTER //
// ./src/types/redeemCode.ts